import { Text } from 'blaze-ui/Text/Text'
import { ShopifyBlogSelect } from '../ShopifyBlogSelect/ShopifyBlogSelect'
import { ShopifyAuthorSelect } from '../ShopifyAuthorSelect/ShopifyAuthorSelect'
import {
  BlogMetadataIntegrationState,
  BlogMetadataIntegrationHandlers,
} from '../../../hooks/useBlogMetadataIntegration'
import Styles from '../../../BlogMetadata.module.scss'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface ShopifyIntegrationFieldsProps {
  integrationState: BlogMetadataIntegrationState
  handlers: BlogMetadataIntegrationHandlers
  isPostPublished: boolean
}

/**
 * Shopify-specific integration fields for Blog and Author selection
 */
export const ShopifyIntegrationFields: React.FC<ShopifyIntegrationFieldsProps> = ({
  integrationState,
  handlers,
  isPostPublished,
}) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { selectedBlogId, selectedAuthorId, availableBlogs, availableAuthors } = integrationState
  const { handleBlogSelect, handleAuthorSelect } = handlers

  const hasOptions = availableBlogs.length > 0 && availableAuthors.length > 0
  const hasMultipleAuthors = availableAuthors.length > 1
  const hasMultipleBlogs = availableBlogs.length > 1

  if (!hasOptions) {
    return (
      <div>
        <Text variant={isSystemRedesignEnabled ? 'secondary' : 'primary'} color="var(--red-70)">
          No blogs or authors were found in your Shopify store. Create them in Shopify, then return here and refresh
          your integration.
        </Text>
      </div>
    )
  }

  return (
    <>
      <div className={Styles.categoryDropdownContainer}>
        {hasMultipleBlogs && <label className={Styles.textFieldLabel}>Blog</label>}
        <div className={Styles.categoryDropdown}>
          <ShopifyBlogSelect
            blogs={availableBlogs}
            selectedBlogId={selectedBlogId}
            onBlogSelect={handleBlogSelect}
            disabled={isPostPublished}
            size={isSystemRedesignEnabled ? 'md' : 'lg'}
          />
        </div>
      </div>

      <div className={Styles.categoryDropdownContainer}>
        {hasMultipleAuthors && <label className={Styles.textFieldLabel}>Author</label>}
        <div className={Styles.categoryDropdown}>
          <ShopifyAuthorSelect
            authors={availableAuthors}
            selectedAuthorId={selectedAuthorId}
            onAuthorSelect={handleAuthorSelect}
            disabled={isPostPublished}
            size={isSystemRedesignEnabled ? 'md' : 'lg'}
          />
        </div>
      </div>
    </>
  )
}
